import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const AffrimPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.AFFIRM}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.AFFIRM)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.AFFIRM)} alt="affirm" />
    </Box>
  );
};
